import { toast } from "sonner";
import type { ToastErrorOptions } from "@/shared/types/error.types";

export type NotificationService = {
  showError: (options: ToastErrorOptions) => void
  showSuccess: (message: string, description?: string) => void
  showInfo: (message: string, description?: string) => void
};

export const createNotificationService = (): NotificationService => {
  return {
    showError: ({ title, description }) => {
      toast.error(title, { description });
    },

    showSuccess: (message: string, description?: string) => {
      toast.success(message, { description });
    },

    showInfo: (message: string, description?: string) => {
      toast.info(message, { description });
    },
  };
};
